import { analyticsTypes } from '../types';

export const reactionMetrics: {
  label: string;
  key: keyof analyticsTypes.InstagramReportRow['reactions'];
}[] = [
  { label: 'Comments', key: 'commentsCount' },
  { label: 'Likes', key: 'likesCount' },
  { label: 'Reposts', key: 'repostsCount' },
];

export const postMetrics: {
  label: string;
  key: keyof analyticsTypes.InstagramReportRow['metrics'];
}[] = [
  { label: 'Buyers count', key: 'buyersCount' },
  { label: 'Checks count', key: 'checksCount' },
  { label: 'Total sum', key: 'totalSum' },
  { label: 'CR', key: 'CR' },
  { label: 'ARPU', key: 'ARPU' },
];
